/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RaiseTicketRightTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomFormTextFieldV2 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";
import { componentStyle } from "../../../config/appTheme";
import CustomMultiSelectV2 from "../../../components/customComponentsV2/common/multiselect/CustomMultiSelectV2";
import CustomTabsV2 from "../../../components/customComponentsV2/common/tabs/CustomTabsV2";
import { useDispatch, useSelector } from "react-redux";
import CustomAutoCompleteWithAPIV2 from "../../../components/customComponentsV2/common/searchBar/CustomAutoCompleteWithAPIV2";
import typeApprovalAPI from "../../../redux/actions/typeApprovalAPI";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import AddButtonV2 from "../../../components/customComponentsV2/common/button/AddButtonV2";
import DynamicFormRenderer from "../../admin-settings/DynamicFormV2/DynamicFormRenderer";
import { DynamicFormDialog } from "../../../components";
import { HandleApiActions, userManagementApis } from "../../../redux/actions";

function RaiseTicketRightTemplate({
  selectedEEMain,
  selectedComponentRequestor = [],
  selectedLegalTechUserDetails = [],
  selectedComponentSupplierDetails = [],
  setSelectedComponentSupplierDetails,
  selectedComplianceRequestors,
  selectedComplianceReviewers,
  setSelectedComplianceRequestor,
  setSelectedComplianceReviewers,
  selectedComplianceSupplier,
  setSelectedComplianceSupplier,
  formType,
  selectedDynamicForm,
  setSelectedDynamicForm,
  handleLocalSaveForm,
  localSubmitDisabled,
  description,
  setDescription,
  savedLinkageCard,
  dynamicFormFilteredData,
  setDynamicFormFilteredData,
  showDynamicSelect = { showDynamicSelect },
  setShowDynamicSelect = { setShowDynamicSelect },
  selectedComponent,
}) {
  const dispatch = useDispatch();
  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const [isDynamicFormDialogOpen, setIsDynamicFormDialogOpen] = useState(false);
  const selectedVariantDetails = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );
  const [openEditDynamicForm, seOpenEditDynamicForm] = useState(false);
  const [projectID, setProjectID] = useState(null);
  const [variantID, setVariantID] = useState(null);
  // const [formTypeId, setFormTypeId] = useState(200);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...userManagementApis.get_users_list_pa,
        show_toast: false,
        params: { page_number: 1, page_size: 500 },
      }),
    ).then((resp) => {
      if (!resp?.error) setUsers(resp.data || []);
    });
  }, []);
  useEffect(() => {
    setProjectID(selectedProjectDetails?.project_id);
  }, [selectedProjectDetails]);

  useEffect(() => {
    setVariantID(selectedVariantDetails?.variant_id);
  }, [selectedVariantDetails]);

  const handelEditDynamicForm = (data) => {
    console.log(
      "---handelEditDynamicForm---",
      selectedDynamicForm?.template_tag,
    );
    if (selectedDynamicForm?.template_tag === "NEW") {
      seOpenEditDynamicForm(!openEditDynamicForm);
    } else if (selectedDynamicForm?.template_tag === "OLD") {
      setIsDynamicFormDialogOpen(!isDynamicFormDialogOpen);
    }
  };

  const handleDynamicFormDialog = (confirm) => {
    if (confirm) {
    }

    setIsDynamicFormDialogOpen(false);
  };
  const handleAddDescDialogClose = (confirm) => {
    console.log(dynamicFormFilteredData, "dynamicFormFilteredData");
    setIsDynamicFormDialogOpen(false);
  };

  const formTypeId = { "ee": 200, "swm": 100, "vehicle-system": 400, "vehicle-component": 300 }[formType] ?? null;


  useEffect(() => {
    console.log("selectedEEMainselectedEEMain", selectedEEMain);
    console.log("Users", users);
    return;
  }, [users, selectedEEMain]);
  const isVariantAvailable = true;
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <CustomFormTextFieldV2
          label={"Description"}
          required={true}
          placeholder="Description"
          retuired={true}
          value={description}
          setValue={setDescription}
        />
      </Grid>
      <Grid item sm={12}>
        <Grid item sm={12}>
          <Box sx={{ borderBottom: "1px solid black" }}>
            <Typography
              sx={{ ...componentStyle.font.cardHeadder, textAlign: "left" }}
            >
              Selected Assignees
            </Typography>
          </Box>
        </Grid>

        <Grid item sm={12}>
          <CustomMultiSelectV2
            label={"Search/Select Compliance Requestors "}
            selectedValues={selectedComplianceRequestors}
            setSelectedValues={setSelectedComplianceRequestor}
            optionsList={
              Array.isArray(selectedComponentRequestor)
                ? selectedComponentRequestor.map((el) => ({
                  value: el.user_id,
                  label: el.name,
                }))
                : []
            }
            required={true}
          />
        </Grid>

        <Grid item sm={12}>
          <CustomMultiSelectV2
            label={"Search/Select Compliance Reviewers "}
            selectedValues={selectedComplianceReviewers}
            setSelectedValues={setSelectedComplianceReviewers}
            optionsList={
              Array.isArray(selectedLegalTechUserDetails)
                ? selectedLegalTechUserDetails.map((el) => ({
                  value: el.user_id,
                  label: el.name,
                }))
                : []
            }
            required={true}
          />
        </Grid>

        <Grid item sm={12}>
          <CustomMultiSelectV2
            label={"Search/Select Suppliers"}
            selectedValues={selectedComplianceSupplier}
            setSelectedValues={setSelectedComplianceSupplier}
            optionsList={
              Array.isArray(selectedComponentSupplierDetails)
                ? selectedComponentSupplierDetails.map((el) => ({
                  value: el.user_id,
                  label: el.name,
                }))
                : []
            }
          // required={true}
          />
        </Grid>
      </Grid>
      <Grid item sm={12}>
        <Grid item sm={12}>
          <Box
            sx={{
              borderBottom: "1px solid black",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{ ...componentStyle.font.cardHeadder, textAlign: "left" }}
            >
              Regulatory Templates
            </Typography>
            <Box sx={{ pr: 1, pb: 0.5 }}>
              <AddButtonV2
                handleOnClick={() => {
                  setShowDynamicSelect((prev) => {
                    setSelectedDynamicForm(null);
                    return !prev;
                  });
                }}
              />
            </Box>
          </Box>
        </Grid>

        {showDynamicSelect ? (
          <Grid container>
            <Grid item xs={12}>
              <CustomTabsV2
                tabs={[
                  {
                    name: "Default Templates",
                    count: "",
                    content: (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        {isVariantAvailable && formTypeId && (
                          <CustomAutoCompleteWithAPIV2
                            key={formTypeId}
                            apiAction={typeApprovalAPI.get_default_templates}
                            searchKey={"name"}
                            placeholder={"Search Template"}
                            skipInitialSearch={false}
                            firstItemDefaultSelect={true}
                            getSelectedItem={(selectedTemplate) => {
                              setSelectedDynamicForm(selectedTemplate);
                              if (selectedTemplate?.template_tag === "OLD") {
                                setDynamicFormFilteredData({
                                  master_template_id: Number(
                                    selectedTemplate?.id,
                                  ),
                                  name: selectedTemplate?.name,
                                  type: selectedTemplate?.type,
                                  template_tag: "OLD",
                                  fields: selectedTemplate?.fields,
                                  headers: selectedTemplate?.headers,
                                  footers: selectedTemplate?.footers,
                                  signatures: selectedTemplate?.signatures,
                                  status: selectedTemplate?.status,
                                });
                              } else if (
                                selectedTemplate?.template_tag === "NEW"
                              ) {
                                setDynamicFormFilteredData({
                                  master_template_id: Number(
                                    selectedTemplate?.id,
                                  ),
                                  name: selectedTemplate?.name,
                                  type: selectedTemplate?.type,
                                  template_tag: "NEW",
                                  fields: selectedTemplate?.fields,
                                  headers: selectedTemplate?.headers,
                                  footers: selectedTemplate?.footers,
                                  signatures: selectedTemplate?.signatures,
                                  status: selectedTemplate?.status,
                                });
                              }
                            }}
                            displayKey={"name"}
                            valueObj={selectedDynamicForm}
                            params={{
                              type: formTypeId,
                              page_number: 1,
                              page_size: 100,
                            }}
                          />
                        )}
                        <CustomButtonV2
                          size="small"
                          disabled={selectedDynamicForm ? false : true}
                          type="submit"
                          btnName="Edit"
                          handleOnClick={() => handelEditDynamicForm()}
                        />
                      </Box>
                    ),
                  },
                  {
                    name: "My Templates",
                    count: "",
                    content: (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        {isVariantAvailable && formTypeId && (
                          <CustomAutoCompleteWithAPIV2
                            key={formTypeId}
                            apiAction={typeApprovalAPI.get_user_dynamic_forms}
                            searchKey={"name"}
                            placeholder={"Search Template"}
                            skipInitialSearch={false}
                            firstItemDefaultSelect={true}
                            getSelectedItem={(selectedTemplate) => {
                              setSelectedDynamicForm(selectedTemplate);
                            }}
                            displayKey={"name"}
                            valueObj={selectedDynamicForm}
                            params={{
                              type: formTypeId,
                              project_id: Number(
                                selectedProjectDetails?.project_id,
                              ),
                              variant_id: Number(
                                selectedVariantDetails?.variant_id,
                              ),
                              page_number: 1,
                              page_size: 100,
                            }}
                          />
                        )}
                        <CustomButtonV2
                          size="small"
                          disabled={selectedDynamicForm ? false : true}
                          type="submit"
                          btnName="Edit"
                          handleOnClick={() => handelEditDynamicForm()}
                        />
                      </Box>
                    ),
                  },
                ]}
              />
            </Grid>
          </Grid>
        ) : null}
      </Grid>
      <Grid item sm={12}>
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <CustomButtonV2
            btnName={"Submit"}
            disabled={localSubmitDisabled}
            handleOnClick={handleLocalSaveForm}
          />
        </Box>
      </Grid>
      <Grid item sm={12}>
        <Grid item sm={12}>
          <Box sx={{ borderBottom: "1px solid black" }}>
            <Typography
              sx={{ ...componentStyle.font.cardHeadder, textAlign: "left" }}
            >
              Saved Linkages
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={12}>
          {savedLinkageCard}
        </Grid>
      </Grid>
      {openEditDynamicForm && (
        <DynamicFormRenderer
          isOpen={openEditDynamicForm}
          onClose={handelEditDynamicForm}
          data={selectedDynamicForm}
          setDynamicFormData={setSelectedDynamicForm}
          dynamicFormFilteredData={dynamicFormFilteredData}
          setDynamicFormFilteredData={setDynamicFormFilteredData}
          selectedComponent={selectedComponent}
        />
      )}
      {isDynamicFormDialogOpen && (
        <>
          {/* Dynamic form dialog */}
          <DynamicFormDialog
            open={isDynamicFormDialogOpen}
            onClose={() => handleDynamicFormDialog(false)}
            dynamicFormData={selectedDynamicForm}
            setDynamicFormData={setSelectedDynamicForm}
            dynamicFormFilteredData={dynamicFormFilteredData}
            setDynamicFormFilteredData={setDynamicFormFilteredData}
            dialogTitle={"Dynamic Form/Template"}
            dialogContent={null}
            onConfirm={() => handleAddDescDialogClose(true)}
            onDisabled={() => { }}
            selectedComponent={selectedComponent}
          />
        </>
      )}
    </Grid>
  );
}

export default RaiseTicketRightTemplate;
